import { IRefIds } from 'constants/refs';
import { del, get, post, put } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IAgentQACreate, IAgentQAEdit, IAgentQAListItem, ITranslationBank } from 'types/agentQA';

export type IAgentQAModelOptions = IModelOptions;

export class AgentQAModel extends BaseModel<IAgentQAListItem, IAgentQAEdit> {
  constructor(options: IAgentQAModelOptions) {
    super(options);
    this.ref = IRefIds.agentQA;
    this.gridName = 'AgentQA';
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IAgentQAListItem[]>(`/agent-qa`);
    this.loadingGrid = false;
    this.render();
  }

  async getGridRow(itemId: number) {
    return await get<IAgentQAListItem>(`/agent-qa/row/${itemId}`);
  }

  async createJob(data: IAgentQACreate) {
    const response = await post<{ id: number; message?: string }>(`/agent-qa`, data);
    await this.getGrid();
    return response;
  }

  async delete() {
    await del(`/agent-qa/${this.itemId}`);
    this.itemId = -1;
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return await get<IAgentQAEdit>(`/agent-qa/${itemId}`);
  }

  async changePriority(itemId: number, priority: number) {
    await put(`/agent-qa/${itemId}/change-priority`, { priority });
  }

  async retryFailedItems(jobId: number) {
    const response = await post<{ id: number }>(`/agent-qa/${jobId}/retry-failed`, {});
    await this.getGrid();
    return response;
  }

  async retryItem(jobId: number, entityKey: string) {
    return await post<{ items_retried: number; entity_key: string; items: any[] }>(
      `/agent-qa/${jobId}/retry-item`,
      { entity_key: entityKey }
    );
  }

  async getAgentTypes() {
    return await get<{ agent_types: any[] }>(`/agent-qa/types`);
  }

  async fetchBanksByAgentType(agentType: string) {
    return await get<ITranslationBank[]>(`/agent-qa/banks?agent_type=${agentType}`);
  }
}
